module.exports = __webpack_public_path__ + "img/CS-Lite-Profiles.bea27e15.jpg";